import { JSX } from 'react';
import clsx from 'clsx';
import Text, { TextProps } from '@components/Text';

export interface InputHelperTextProps extends TextProps {
  error?: boolean;
}

function InputHelperText({
  children,
  className,
  error,
  ...rest
}: InputHelperTextProps): JSX.Element {
  return (
    <Text
      className={clsx('mt-2', className)}
      color={error ? 'red-50' : 'white'}
      size="body2"
      {...rest}
    >
      {children}
    </Text>
  );
}

export default InputHelperText;
